module.exports = __webpack_public_path__ + "components/flag/static/square/dk-1cd74ef42911c033029271e1738c212b.svg";